var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoginEye = function SvgLoginEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#727582",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M14.585 8.096c.11.26.11.546 0 .807-.524 1.242-2.428 4.93-6.586 4.93-4.16 0-6.062-3.69-6.584-4.931-.11-.26-.11-.545 0-.805C1.937 6.855 3.84 3.166 8 3.166c4.158 0 6.062 3.687 6.586 4.93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#727582",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.667 8.5a2.667 2.667 0 1 1-5.333 0 2.667 2.667 0 0 1 5.333 0"
  })));
};
export default SvgLoginEye;